import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

let escapeListener = null;

const $format = unwrapFunctionStore(format);

export const cloneToDomain = {
  element: '.modal-content',
  popover: {
    title: $format('label.TOURS.STUDIO.CLONE.CLONE_TO_DOMAIN.TITLE'),
    description: $format('label.TOURS.STUDIO.CLONE.CLONE_TO_DOMAIN.DESCRIPTION'),
    side: 'left',
    align: 'start',
    onPopoverRender: () => {
      const closeButton = document.querySelector('.close');

      escapeListener = (event) => {
        if (event.key === 'Escape') {
          if (closeButton) {
            closeButton.click();
          }
          document.removeEventListener('keydown', escapeListener);
        }
      };

      document.addEventListener('keydown', escapeListener);
    },
    onPrevClick: () => {
      const actionsButton = document.querySelector('.os-icon-more-horizontal');
      const closeButton = document.querySelector('.close');

      if (escapeListener) {
        document.removeEventListener('keydown', escapeListener);
      }

      if (closeButton) {
        closeButton.click();
      }

      if (actionsButton) {
        actionsButton.click();

        GLOBAL_DRIVER_OBJECT.movePrevious();
      }
    },
    onNextClick: () => {
      const closeButton = document.querySelector('.close');

      if (escapeListener) {
        document.removeEventListener('keydown', escapeListener);
      }

      if (closeButton) {
        closeButton.click();

        GLOBAL_DRIVER_OBJECT.moveNext();
      }
    }
  }
};
